import { Check, Warning } from '@oresundsbron/icons';
import { useTranslation } from 'next-i18next';

export enum ResponseStatus {
  error = 'error',
  hide = 'hide',
  success = 'success',
}

interface ResponseBannerProps {
  status: ResponseStatus;
  successText: string;
  errorText: string;
}

export const ResponseBanner = ({
  status,
  successText,
  errorText,
}: ResponseBannerProps) => {
  const { t } = useTranslation(['common'], {
    nsMode: 'fallback',
  });
  const commonClasses = 'flex items-center text-xs py-3 px-4 mt-8';
  const showBanner = () => {
    switch (status) {
      case 'success':
        return (
          <div className={`${commonClasses} bg-green-100 text-green-800`}>
            <Check className="mr-4" /> {successText}
          </div>
        );
      case 'error':
        return (
          <div className={`${commonClasses} bg-red-100 text-red-700`}>
            <Warning className="mr-4" /> {errorText}
          </div>
        );
      default:
        return <></>;
    }
  };
  return showBanner();
};

export default ResponseBanner;
